import http from "../../../services/httpService";

export const getAbout = () => {
  let about = localStorage.getItem("about");
  if (about) {
    about = JSON.parse(about);
  }
  return about;
};

export const fetchProfile = async () => {
  const { data } = await http.get(`/business/get_company_profile/`, {
    params: {
      userplan_id: localStorage.getItem("userplan_id"),
    },
  });
  if (data && data.data) return data.data;
  return null;
};

export const updatePassword = async (email, password) => {
  console.log({ email, password });
  try {
    let { data } = await http.post("/phone/update_employer_password/", {
      email,
      password,
    });
  } catch (err) {
    console.log({ err });
    alert("Backend Error");
  }
};

export const getUserDetailFromEmail = (email, profile) => {
  console.log({ email, profile });
  const user = {
    name: null,
    phone: null,
  };
  if (profile.email == email) {
    user["name"] = profile.primary_contact_name;
    user["phone"] = profile.phone;
  } else if (profile.secondary_email == email) {
    user["name"] = profile.primary_contact_name;
    user["phone"] = profile.phone;
  }

  return user;
};
